const actions = {
  allowanceCardDesignApiName: 'ALLOWANCE_CARD_DESIGN_API',
  requestAllowanceCardDesign: 'allowanceCardDesign/request',
}

export default actions
